module.exports = "/_next/static/images/letter-line-5a93ea8d9ad5149c77538705b4c43b2c.svg";